import { ReactNode } from 'react';
import { OverflowMenu } from 'ui/actionMenu';
import { ActionMenuOption } from 'ui/actionMenu/types';
import { BUTTON_SIZES } from 'ui/button';
import { Actions, Details, Metadata, Name, Row } from './CollapsibleContentCard.styled';

type Props = {
  id: string | number;
  metadata: string | ReactNode;
  options?: ActionMenuOption[];
  subtitle: ReactNode | string;
};

export const CollapsibleContentCardRow = ({ id, metadata, options, subtitle }: Props) => {
  return (
    <Row id={`row-${id}`} data-test={`content-card-row`}>
      <Details>
        <Name>{subtitle}</Name>
        <Metadata>{metadata}</Metadata>
      </Details>
      {options?.length && (
        <Actions>
          <OverflowMenu options={options} size={BUTTON_SIZES.SMALL} id={`row-${id}-options`} />
        </Actions>
      )}
    </Row>
  );
};
